/* eslint-disable quotes */
import { h } from 'vue';

const body = `<h4>Show shadows</h4>

<p>Show or hide the shadow of the model.</p>`;

export default function ToggleShadowTooltip() {
    return h('div', { innerHTML: body });
}
